import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import NotificationItem from "./notification_item";
import Loader from "./loader";

const NotificationListForApp = ({ companyId = null }) => {
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [page, setPage] = useState(1);
  const [isLast, setIsLast] = useState(false);
  const [isLoadingNextList, setIsLoadingNextList] = useState(false);
  const ancLastItemRef = useRef(null);
  const isEnableNextLoad = useRef(true);

  const loadInitialNotifications = useCallback(() => {
    setLoading(true);
    axios
      .get("/api/notification/notifications", { params: { company_id: companyId } })
      .then((response) => {
        setNotifications(response.data.notifications);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [companyId]);

  const loadNextNotifications = useCallback(() => {
    if (loading || isLast) return;

    setLoading(true);
    setIsLoadingNextList(true);

    axios
      .get("/api/notification/notifications", {
        params: {
          company_id: companyId,
          page: page + 1,
        },
      })
      .then((response) => {
        if (response.data.notifications.length === 0) {
          setIsLast(true);
        } else {
          setNotifications((prevNotifications) => [
            ...prevNotifications,
            ...response.data.notifications,
          ]);
          setPage((prevPage) => prevPage + 1);
        }
        setLoading(false);
        setIsLoadingNextList(false);
      })
      .catch(() => {
        setLoading(false);
        setIsLoadingNextList(false);
      });
  }, [companyId, loading, isLast, page]);

  const setIsCheckedToServer = useCallback(() => {
    axios
      .post(
        "/api/notification/is_checked",
        { company_id: companyId },
        {
          headers: { "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content },
        }
      )
      .catch(() => {});
  }, [companyId]);

  useEffect(() => {
    loadInitialNotifications();
    setIsCheckedToServer();
  }, [loadInitialNotifications, setIsCheckedToServer]);

  const handleScrollEvent = useCallback(() => {
    const ancPosition = ancLastItemRef.current.offsetTop;
    const scrolled = window.scrollY;
    if (ancPosition - 1000 < scrolled && scrolled < ancPosition && isEnableNextLoad.current) {
      isEnableNextLoad.current = false;
      loadNextNotifications();
    }
  }, [loadNextNotifications]);

  useEffect(() => {
    isEnableNextLoad.current = !isLoadingNextList;

    if (typeof window !== "undefined") {
      if (isLast) {
        window.removeEventListener("scroll", handleScrollEvent);
      } else {
        window.addEventListener("scroll", handleScrollEvent);
      }

      return () => {
        window.removeEventListener("scroll", handleScrollEvent);
      };
    }
  }, [isLast, isLoadingNextList, handleScrollEvent]);

  const notificationItems = notifications.length ? (
    notifications.map((item) => <NotificationItem notificationItem={item} key={item.id} />)
  ) : !loading ? (
    <div style={{ 
      padding: "10px",
      display: "block",
      textAlign: "center",
    }}>
      <span style={{ display: "block", marginBottom: "20px", marginTop: "20px", fontSize: "20px" }}>お知らせはありません</span>
      <img
        src="/assets2019/img/top/tunagate_top01.jpg"
        alt="つなげーとアプリ"
        style={{ 
          display: "block",
          width: "70vw",
          maxWidth: "400px",
          height: "auto",
          margin: "0 auto",
          marginTop: "60px"
        }}
      />
    </div>
  ) : null;

  return (
    <div style={{ padding: "0" }}>
      <Loader isActive={loading} />
      {notificationItems}
      <div id="ancLastItem" ref={ancLastItemRef} />
    </div>
  );
};

export default NotificationListForApp;
